// 1. Import `extendTheme`
import { createSystem, defaultConfig } from '@chakra-ui/react';

import '@fontsource/poppins';

export const system = createSystem(defaultConfig, {
    theme: {
        tokens: {
            fonts: {
                heading: { value: `'Poppins', sans-serif` },
                body: { value: `'Poppins', sans-serif` },
            },
            colors: {
                brand: {
                    100: { value: '#005aa0', description: 'Default Blue' },
                    110: { value: '#004173', description: 'Hover Blue' },
                },
                light: {
                    100: { value: '#f4f7fb', description: 'Light Blue' },
                },
            },
        },
    },
});
